/**
 * FileData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { FileActionData } from './file_action_data'
import type { FileInfo } from './file_info'
import type { FileReferenceData } from './file_reference_data'
import type { FileStats } from './file_stats'

/**
 * FileData
 */
export interface FileData {
  /** 文件ID */
  id?: string
  /** 文件基础信息 */
  info?: FileInfo
  /** 文件统计信息 */
  stats?: FileStats
  /** 引用列表 */
  references?: FileReferenceData[]
  /** 操作记录 */
  actions?: FileActionData[]
}

/**
 * FileData Schema
 */
export const FileDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '文件ID',
      format: 'string',
      type: 'string',
      label: '文件ID',
    },
    info: {
      $ref: 'FileInfo',
      description: '文件基础信息',
      label: '文件基础信息',
    },
    stats: {
      $ref: 'FileStats',
      description: '文件统计信息',
      label: '文件统计信息',
    },
    references: {
      description: '引用列表',
      format: '[]*model.FileReferenceData',
      items: { $ref: 'FileReferenceData', description: '' },
      type: 'array',
      label: '引用列表',
    },
    actions: {
      description: '操作记录',
      format: '[]*model.FileActionData',
      items: { $ref: 'FileActionData', description: '' },
      type: 'array',
      label: '操作记录',
    },
  },
  type: 'object',
}
